'use client';

import {
  Conditional,
  Drawer,
  FooterCommonLink,
  useDrawer
} from '@cat-ecom/pcc-components';
import { Portal } from 'components/pcc-components';

import { ROOT_PORTALS } from 'constants/targets';
import { useSisUrl } from 'hooks/use-sis-url';
import { FC, PropsWithChildren } from 'react';

type SISLinkClientProps = {
  label: string;
  isLoggedIn: boolean;
  isFooterDesigneUpdate: boolean;
  isEnhancedPccToSisNonOrderFlowFlag: boolean;
};
export const SISLinkClient: FC<PropsWithChildren<SISLinkClientProps>> = ({
  label,
  isLoggedIn,
  isFooterDesigneUpdate,
  isEnhancedPccToSisNonOrderFlowFlag,
  children
}) => {
  const { drawerProps, initiatorProps } = useDrawer();
  const { returnPage, getLegacySisUrl, sisUrlMutation } = useSisUrl(isLoggedIn, isEnhancedPccToSisNonOrderFlowFlag);
  
  const handleSisClick: React.MouseEventHandler<HTMLAnchorElement> = (e: React.MouseEvent) => {
  if (isEnhancedPccToSisNonOrderFlowFlag) {
    e.preventDefault();
    (async () => {
      try {
        const sisUrl = await sisUrlMutation.mutateAsync(returnPage);
        if (sisUrl) {
          window.location.href = sisUrl;
        }
      } catch (error) {
        console.error('Failed to fetch SIS link:', error);
      }
    })();
  }
};

const legacySisUrl = getLegacySisUrl();

const linkProps = isEnhancedPccToSisNonOrderFlowFlag
  ? {
      onClick: handleSisClick,
      ...(!isLoggedIn ? initiatorProps : {})
    }
  : {
      href: legacySisUrl,
      ...(!isLoggedIn ? initiatorProps : {})
    };

  return (
    <>
      <FooterCommonLink
        isMobile={isFooterDesigneUpdate}
        label={label}
        {...linkProps}
      />
      <Conditional test={!isLoggedIn}>
        <Portal id={ROOT_PORTALS}>
          <Drawer {...drawerProps}>{children}</Drawer>
        </Portal>
      </Conditional>
    </>
  );
};
